export default function ReceiptSummaryTable({ data }) {
	return (
		<div className="receipt" style={{ marginTop: "0" }}>
			<table className="order">
				<thead>
					<tr>
						<th style={{ width: "15%" }}>Order ID</th>
						<th style={{ width: "35%" }}>Name</th>
						<th style={{ width: "35%" }}>Email</th>
						<th style={{ width: "15%" }}>Date</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{data.id}</td>
						<td>{data.name}</td>
						<td>{data.email}</td>
						<td>{data.date}</td>
					</tr>
					{data.method === "check" && (
						<tr>
							<td
								colSpan="4"
								style={{ paddingTop: "15px", paddingBottom: "15px" }}
							>
								<p>
									Mail your check payable to:
									<br />
									<span style={{ fontWeight: "400" }}>
										Children’s Healthcare Charity, Inc.
									</span>
								</p>
								<p>CHC/CC, 219 Golf Club Circle, Jupiter, FL 33469</p>
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
}
